/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropwinnersattach2Inputs */

const en_dropwinnersattach2 = /** @type {(inputs: Dropwinnersattach2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach file`)
};

const de_dropwinnersattach2 = /** @type {(inputs: Dropwinnersattach2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei anhängen`)
};

/**
* | output |
* | --- |
* | "Attach file" |
*
* @param {Dropwinnersattach2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnersattach2 = /** @type {((inputs?: Dropwinnersattach2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnersattach2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnersattach2(inputs)
	return de_dropwinnersattach2(inputs)
});
export { dropwinnersattach2 as "dropWinnersAttach" }